import React, { useCallback, useEffect, useState } from "react";

// <--------- MUI Components --------->
import { Divider } from "@mui/material";

// <--------- React Bootstrap -------->
import { Col, Row } from "react-bootstrap";

// <--------- Essential Components -------->
import {
  DatePicker,
  SelectWithRadio,
  Select,
  TextInput,
  Question,
} from "../../../components";
import Button from "../../../components/Buttons/Button";

// Redux Hooks
import { useDispatch, useSelector } from "react-redux";

// Actions
import { executeCalculator } from "store/actions/products";

import GIFLoader from "../../../assets/images/loader.gif";
import validate from "validate.js";
import useWindowDimensions from "utils/useWindowDimension";
import { toast } from "react-toastify";
import { updateStepValue } from "store/actions/products";
import { UpdateSteps } from "store/actions/products";
import { isValid } from "store/actions/products";
import { RESTRICTED_QUESTIONS } from "utils/constants";

const Step1 = ({ handleNext, data, setActiveStep, failedSteps }) => {
  // Attributes  i.e Account holder or Account number
  const [attributes, setAttributes] = useState([]);

  // Redux Hooks
  const dispatch = useDispatch();

  // Risk attributes from the Product i.e. BUD, CEU, ICU, etc.
  const riskAttributes = useSelector((state) => state.products.riskAttributes);

  // Validation constraints
  const [constraints, setConstraints] = useState({});


  // Loader state
  const [isLoading, setIsLoading] = useState(false);

  const [characterLimitError, setCharacterLimitError] = useState("")

  // Type ID
  const typeID = useSelector(
    (state) =>
      state.products.types.types && state.products.types.types[0].instanceId
  );

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (data?.attributes?.length) {
      // Setting up the risk attributes for Step 1

      var arr = [];

      riskAttributes
        .filter((filter) => filter.code !== "SPB")
        .forEach((ex) => {
          if (ex.attributes) {
            ex.attributes.forEach((ey) => {
              if(ey.name !== "Company Types"){
              arr.push({ ...ey, type: ex.code });
              }
            });
          }
        });

      setAttributes(
        arr.map((f) => ({
          ...f,
          dataType: RESTRICTED_QUESTIONS.TYPE_LIST_8.includes(f.instanceId)
            ? 8
            : f.dataType,
        }))
      );

      // Setting up the risk attributes constraints for form validations
      var obj = {};
      arr
      //.filter((x) => !RESTRICTED_QUESTIONS.HIDE_QUESTIONS.includes(x.instanceId))
      .forEach((ex, i) => {
        if (ex.isRequired) {
          obj = {
            ...obj,
            [ex.name.replaceAll(" ", "")]: { presence: { allowEmpty: false } },
          };
        }
        if (i === arr.length - 1) {
          setConstraints(obj);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // const handleChange = (evt, instanceID) => {
  //   const elementIndex = attributes?.findIndex(
  //     (ele) => ele.instanceId === instanceID
  //   );
  //   var arr = [...attributes];
  //   arr[elementIndex] = {
  //     ...arr[elementIndex],
  //     value: evt.target.value,
  //     errors: arr[elementIndex]?.value && [],
  //   };
  //   setAttributes(arr);
  //   dispatch(
  //     updateStepValue({
  //       code: arr[elementIndex].type,
  //       attributes: arr.filter((d) => d.type === arr[elementIndex].type),
  //     })
  //   );
  // };

  ///---new--Check for ServiceIndustry--//
  const handleChange = (evt, instanceID) => {
    const elementIndex = attributes?.findIndex(
      (ele) => ele.instanceId === instanceID
    );
    const arr = [...attributes];
    const currentValue = evt.target.value;

    if (
      arr[elementIndex]?.name === "Services/Industry" &&
      currentValue.length > 280
    ) {
      // If the attribute is "Services/Industry" and exceeds 280 characters, set error
      arr[elementIndex] = {
        ...arr[elementIndex],
        value: currentValue,
        errors: ["Description of services or industry is limited to 280 characters"],
      };
    } else {
      // Otherwise, clear errors
      arr[elementIndex] = {
        ...arr[elementIndex],
        value: currentValue,
        errors: [],
      };
    }

    setAttributes(arr);
    dispatch(
      updateStepValue({
        code: arr[elementIndex].type,
        attributes: arr.filter((d) => d.type === arr[elementIndex].type),
      })
    );
  };

  // Render fields
  const renderComponent = useCallback(
    (type, idx) => {
      switch (type.dataType) {
        case 7:
          return (
           <Col id={type.name} className="p-3" sm={width > 770 ? ((idx%2) === 1  ? 6 : 6) : 12}>
             <Question
              vertical={true}
              labelStyle={{ height: "60px", marginTop: "20px" }}
              errors={type.errors}
              detailed={type.name.includes("BUD") && type.value === "No"}
              question={type.description}
              label={
                attributes.filter(
                  (filter) =>
                    filter.name.slice(
                      filter.name.length - 8,
                      filter.name.length
                    ) ===
                      type.name.slice(type.name.length - 8, type.name.length) &&
                    filter.name.includes("NO")
                )[0]?.description
              }
              required={false}
              value={type.value}
              placeholder={type.description}
              options={JSON.parse(type?.settings)?.items}
              detailedValue={
                attributes.filter(
                  (filter) =>
                    filter.name.slice(
                      filter.name.length - 8,
                      filter.name.length
                    ) ===
                      type.name.slice(type.name.length - 8, type.name.length) &&
                    filter.name.includes("NO")
                )[0]?.value
              }
              onChange={(evt) => handleChange(evt, type.instanceId)}
              onDetailedChange={(evt) =>
                handleChange(
                  evt,
                  attributes.filter(
                    (filter) =>
                      filter.name.slice(
                        filter.name.length - 8,
                        filter.name.length
                      ) ===
                        type.name.slice(
                          type.name.length - 8,
                          type.name.length
                        ) && filter.name.includes("NO")
                  )[0]?.instanceId
                )
              }
            />
           </Col>
          );

        case 2:
          return (
            <Col id={type.name} className="p-3"  sm={width > 770 ? ((idx%2) === 1  ? 6 : 6) : 12}>
              <SelectWithRadio
                vertical={true}
                errors={type.errors}
                label={type.description || type.name}
                required={false}
                value={type.value || ""}
                placeholder={type.description}
                options={JSON.parse(type?.settings)?.items}
                onChange={(evt) => handleChange(evt, type.instanceId)}
              />
            </Col>
          );
        case 8:
          return (
            <Col id={type.name} className="p-3"   sm={width > 770 ? ((idx%2) === 1  ? 6 : 6) : 12}>
              <Select
                vertical={true}
                required={false}
                errors={type.errors}
                label={type.description || type.name}
                value={type.value || ""}
                placeholder={type.description}
                options={JSON.parse(type?.settings)?.items}
                onChange={(evt) => handleChange(evt, type.instanceId)}
              />
            </Col>
          );
        case 1:
          return (
            <Col
              id={type.name}
              className="p-3"
              sm={width > 770 ? (idx % 2 === 1 ? 6 : 6) : 12}
            >
              <TextInput
                required={false}
                errors={type.errors}
                type="text"
                placeholder={type.description}
                label={type.description}
                value={type.value || ""}
                onChange={(evt) => handleChange(evt, type.instanceId)}
              />
            </Col>
          );

        case 3:
          return (
            <Col id={type.name} className="p-3"  sm={width > 770 ? ((idx%2) === 1  ? 6 : 6) : 12}>
              <TextInput
                required={false}
                errors={type.errors}
                type="number"
                placeholder={type.description}
                label={type.description}
                value={type.value || ""}
                onChange={(evt) => handleChange(evt, type.instanceId)}
              />
            </Col>
          );

        case 5:
          return (
            <Col id={type.name} className="p-3"  sm={width > 770 ? ((idx%2) === 1  ? 6 : 6) : 12}>
              <DatePicker
                required={false}
                value={type.value}
                placeholder={type.description}
                errors={type.errors}
                onChange={(evt) => handleChange(evt, type.instanceId)}
                label={type.description}
              />
            </Col>
          );

        default:
          return;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [attributes, riskAttributes]
  );

  const handleSubmit = async (evt) => {
    // console.log("characterrlimm", characterLimitError);
    evt.preventDefault();
    // <---- Consolidating Errors values ---->
    var values = {};
    attributes
      .filter(
        (x) => !RESTRICTED_QUESTIONS.HIDE_QUESTIONS.includes(x.instanceId)
      )
      .filter((f) => f.isRequired)
      .forEach((ex, i) => {
        if (ex.isRequired) {
          values = { ...values, [ex.name.replaceAll(" ", "")]: ex.value };
        }
      });

    // <---- Errors check ---->
    const errors = validate(values, constraints);
    console.log(errors);
    // Check for "Services/Industry" character limit error
    const servicesIndustryAttribute = attributes.find(
      (attr) => attr.name === "Services/Industry"
    );

    if (
      servicesIndustryAttribute?.value &&
      servicesIndustryAttribute.value.length > 280
    ) {
      // If the attribute value exceeds 280 characters, set error
      setAttributes((prevAttributes) =>
        prevAttributes.map((ex) =>
          ex.instanceId === servicesIndustryAttribute.instanceId
            ? {
                ...ex,
                errors: [
                  "Description of services or industry is limited to 280 characters",
                ],
              }
            : ex
        )
      );

      const divID = document.getElementById(
        servicesIndustryAttribute.instanceId
      );

      if (divID) {
        window.scrollTo({
          top: divID.offsetTop,
          behavior: "smooth",
        });
      }

      return;
    }
    ///Check for "Services/Industry" character limit error-END/
    if (errors || errors !== undefined) {
      setAttributes(
        attributes
          .filter(
            (x) => !RESTRICTED_QUESTIONS.HIDE_QUESTIONS.includes(x.instanceId)
          )
          .map((ex) => ({
            ...ex,
            errors: errors[ex.name.replaceAll(" ", "")],
          }))
      );
      const err = attributes
        .filter(
          (x) => !RESTRICTED_QUESTIONS.HIDE_QUESTIONS.includes(x.instanceId)
        )
        .filter((y) =>
          Object.keys(errors).includes(y.name.replaceAll(" ", ""))
        );
      const divID = document.getElementById(err[0]);
      if (divID) {
        window.scrollTo({
          top: divID.offsetTop,
          behavior: "smooth",
        });
      }
      return;
    }

    try {
      setIsLoading(true);
      // <---- Dispatching values for executeCalculators ---->
      dispatch(
        executeCalculator({
          factors: [],
          risks: [
            {
              attributes: attributes
                .filter((filter) => filter.value && filter.type === "BUD")
                .map((d) => ({
                  dataType: d.dataType === 2 ? 7 : d.dataType,
                  name: d.name,
                  instanceId: d.instanceId,
                  value: d.value,
                })),
              riskReference: riskAttributes?.find((x) => x.code === "BUD")
                ?.instanceId,
              code: "BUD",
            },
          ],
          productTypeReference: typeID,
        })
      )
        .then((y) => {
          attributes.forEach(async (ex) => {
            if (ex.value && ex.value.toString() === "No") {
              dispatch(isValid(false));
              await dispatch(UpdateSteps(1));
              await setActiveStep(1);
              failedSteps([1]);
            } else {
              const industryQuestion = attributes.find((f) =>
                RESTRICTED_QUESTIONS.INDUSTRY_QUESTION.includes(f.instanceId)
              );

              const annualTurnover = attributes.find((f) =>
                RESTRICTED_QUESTIONS.ANNUAL_TURNOVER.includes(f.instanceId)
              );

              if (
                industryQuestion.value.includes("*") ||
                annualTurnover.value.includes("Above")
              ) {
                dispatch(isValid(false));
                await dispatch(UpdateSteps(1));
                await setActiveStep(1);
                failedSteps([1]);
              } else {
                failedSteps([]);
                dispatch(isValid(true));
                dispatch(UpdateSteps(1));
                setIsLoading(false);
                setActiveStep(1);
                handleNext(1);
              }
            }
          });
        })
        .catch((er) => {
          toast.error(
            er?.response?.data?.message || er?.response?.data || "Error Occured"
          );
        });
    } catch (err) {
      console.log(err);
      toast.error(
        err?.response?.data?.message || err?.response?.data || "Error Occured"
      );
      setIsLoading(false);
    }
  };

  return data?.attributes ? (
    <div>
      {/* <---------- Title -------> */}
      <h4>{data?.title}</h4>

      {/* <---------- Title -------> */}
      <h6>{data?.sub}</h6>

      <Divider row={2} />

      {/* <------- Attributes Starts ------> */}

      <form onSubmit={handleSubmit}>
        <Row className="justify-content-between">
          {attributes &&
            attributes
              .filter((x) => !RESTRICTED_QUESTIONS.HIDE_QUESTIONS.includes(x.instanceId))
              .filter(
                (f) =>
                  !RESTRICTED_QUESTIONS.HIDDEN_QUESTIONS.includes(f.instanceId)
              )
              ?.map((d, i) => (
                
                  renderComponent(d, i
                     
                    )
               
              ))}
        </Row>
        <Row
          className={
            width > 430 ? "justify-content-end" : "justify-content-center"
          }
        >
          <Button
            type="submit"
            isLoading={isLoading}
            containerStyle={{ width: 200 }}
            name="Get Quote"
            bg="#DA291C"
            onClick={() => null}
            color="white"
            id="form-1-quote-button"
          />
        </Row>
      </form>

      {/* <------- Attributes Ends ------> */}
    </div>
  ) : (
    <div className="gif-loader">
      <img src={GIFLoader} alt="GIF LOADER"></img>
    </div>
  );
};

export default Step1;
